import { render } from "./signature-pad-base.vue?vue&type=template&id=4b23f473"
import script from "./signature-pad-base.vue?vue&type=script&lang=js"
export * from "./signature-pad-base.vue?vue&type=script&lang=js"

import "./signature-pad-base.vue?vue&type=style&index=0&id=4b23f473&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__